import { useTranslation } from "@redotech/redo-i18n";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";
import { FeedbackCallout } from "./feedback-callout";
import { useFeedbackPopover } from "./feedback-popover-context";

/**
 * Must stay inside AskRedoSlidePanelProvider — FeedbackCallout calls
 * useAskRedoSlidePanel(), which throws without that provider above it.
 */
export const FeedbackCalloutHost = memo(function FeedbackCalloutHost() {
  const { t } = useTranslation();
  const { isOpen, close } = useFeedbackPopover();

  if (!isOpen) {
    return null;
  }

  return (
    <RedoModal
      hideFooter
      isOpen
      modalSize="sm"
      onModalCloseRequested={close}
      title={t("Give feedback", {
        context: "top navigation panel title for submitting product feedback",
      })}
    >
      <FeedbackCallout onClose={close} />
    </RedoModal>
  );
});
